import {defineNuxtRouteMiddleware} from '#app';
import {navigateTo} from '#imports';
import {ROUTES_NAMES} from '~/common/routes';

const DEPRECATED_PAGE_PATHS = [ROUTES_NAMES.billingContact];

export default defineNuxtRouteMiddleware(async (to) => {
    const isDeprecatedPage = DEPRECATED_PAGE_PATHS.some((deprecatedPath) => {
        const matches = to.path.endsWith(`/${deprecatedPath}`);
        return matches;
    });

    if (isDeprecatedPage) {
        // TODO: use the actual legal entity id when it's available
        return await navigateTo(`/client-settings/legal-entity/${to.params.id}`, {external: true});
    }
});
